<template>
  <div>
    <v-container fluid v-if="items">
      <!-- {{ activeIndex }}
    {{ interval }} -->
      <!-- <v-btn @click="clearInterval()">clear</v-btn> -->
      <!-- <div class="d-flex flex-wrap">
      <v-chip
        class="ma-5 px-5"
        large
        color="primary"
        @click="toggle"
        v-for="(feature, index) in features"
        :key="index"
      >
        <v-icon left>mdi-check</v-icon>
        <span v-text="feature"></span>
      </v-chip>
    </div> -->
      <v-row v-if="slides">
        <v-slide-group v-model="activeIndex" class="pa-4" center-active show-arrows>
          <v-slide-item v-for="(feature, index) in items" :key="index" v-slot="{ toggle }">
            <v-chip class="ma-5 px-5" style="cursor: Default" large color="primary" @click="toggle">
              <v-icon left>mdi-check</v-icon>
              <span v-text="feature"></span>
            </v-chip>
          </v-slide-item>
        </v-slide-group>
      </v-row>
      <v-row v-else justify="center" class="mt-3">
        <v-col style="max-width: 700px">
          <v-row justify="space-around">
            <span
              v-for="(feature, index) in items"
              :key="index"
              style="width: 320px"
              class="my-2 w-100 d-flex text-body-1"
            >
              <v-icon class="mx-3" color="primary">mdi-check</v-icon>
              <span v-text="feature"></span>
            </span>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  mounted() {
    // this.setInterval();
    // this.interval;
  },
  beforeDestroy() {
    // this.clearInterval();
  },
  data() {
    return {
      //   interval: "x",
      activeIndex: 1,

      //   [
      //     "Analüütika",
      //     "Turundus",
      //     "Online broneerimine",
      //     "SMS klienditeated",
      //     "E-maili klienditeated",
      //     "Töötajate haldamine",
      //     "Kalender",
      //     "Iseteeninduskeskkond kliendile",
      //   ],
    };
  },
  computed: {
    slides() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
    features() {
      return this.$t("copy.horizontalFeatures");
    },
    items() {
      if (this.features === "copy.horizontalFeatures") return null;
      return this.features.split(" | ");
    },
  },
  //   computed: {
  //     computedFeatures() {
  //       return [
  //         ...this.features,
  //         ...this.features,
  //         ...this.features,
  //         ...this.features,
  //         ...this.features,
  //         ...this.features,
  //         ...this.features,
  //       ];
  //     },
  //   },
  //   methods: {
  //     setInterval() {
  //       this.inerval = setInterval(() => {
  //         const maxIndex = this.features.length - 1;
  //         if (this.activeIndex === maxIndex) {
  //           this.activeIndex = 0;
  //           return;
  //         }

  //         this.activeIndex = this.activeIndex + 1;
  //       }, 1000);
  //     },
  //     clearInterval() {
  //       clearInterval(this.interval);
  //     },
  //   },
};
</script>
